import * as React from 'react';
import styled from 'styled-components';

import { flexGap, verticalSpace } from '@doltech/utils/lib/css-style';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { OptionAudioAnimate } from '@doltech/ui/lib/figma/Audio/Player/LottieAnimate/OptionAudioAnimate/OptionAudioAnimate';
import { ButtonIconPrimaryGeneral } from '@doltech/ui/lib/figma/Button/ButtonIconPrimaryGeneral/ButtonIconPrimaryGeneral';
import { PronunciationProgressIconButton } from '../PronunciationProgressIconButton/PronunciationProgressIconButton';

const WordInfo = styled.div`
  display: none;

  ${fromScreen(768)} {
    display: grid;
    grid-template-columns: 108px minmax(0, 1fr);
    align-items: center;
    column-gap: 8px;
  }
`;

const Action = styled.div`
  display: flex;
  align-items: center;
  ${flexGap(8)}
`;

const Term = styled.div`
  display: flex;

  ${fromScreen(768)} {
    .term-pronunciation {
      display: none;
    }
  }
`;

const Word = styled.div`
  ${verticalSpace(8)}

  ${fromScreen(768)} {
    display: flex;
    align-items: center;

    ${verticalSpace(0)}

    .word-meaning {
      display: none;
    }
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  column-gap: 12px;

  padding: 12px 0;

  ${fromScreen(768)} {
    grid-template-columns: 154px auto minmax(0, 1fr);
    align-items: center;
    column-gap: 8px;
  }
`;

interface VocabContentItemProps {
  enWord?: string;
  viWord?: string;
  pronunciation?: string;
  onStartPronunciation?: () => void;
  onPlayText?: () => void;
  isLearned?: boolean;
  audioPlaying?: boolean;
}

export const VocabContentItem = (props: VocabContentItemProps) => {
  const { enWord, viWord, pronunciation, onStartPronunciation, onPlayText, isLearned = false, audioPlaying = false } = props;

  return (
    <Container className="vocab-content-item">
      <Word>
        <Term>
          <ResponsiveTypography.Paragraph variant="semi-bold/14-20" color="neutral180" mr="8px">
            {enWord}
          </ResponsiveTypography.Paragraph>
          <ResponsiveTypography.Paragraph className="term-pronunciation" variant="regular/14-20" color="neutral120">
            {pronunciation}
          </ResponsiveTypography.Paragraph>
        </Term>
        <ResponsiveTypography.Paragraph className="word-meaning" variant="regular/14-20" color="neutral120">
          {viWord}
        </ResponsiveTypography.Paragraph>
      </Word>
      <Action>
        <PronunciationProgressIconButton
          status={isLearned ? 'done' : 'not-yet'}
          onStartPronunciation={onStartPronunciation}
        />
        <ButtonIconPrimaryGeneral
          size="large"
          type="blue"
          colorStyle="matte"
          backgroundStyle="light"
          buttonStyle="filled"
          icon={<OptionAudioAnimate isPlaying={audioPlaying} />}
          onClick={onPlayText}
        />
      </Action>
      <WordInfo>
        <ResponsiveTypography.Paragraph variant="regular/14-20" color="neutral180">
          {pronunciation}
        </ResponsiveTypography.Paragraph>
        <ResponsiveTypography.Paragraph variant="regular/14-20" color="neutral180">
          {viWord}
        </ResponsiveTypography.Paragraph>
      </WordInfo>
    </Container>
  );
};
